import React from 'react';
import * as AccordionPrimitive from '@radix-ui/react-accordion';
import { ChevronDown } from 'lucide-react';

const FAQAccordion = ({ faqs }) => {
  return (
    <div className="w-full" data-testid="faq-accordion">
      <AccordionPrimitive.Root type="single" collapsible className="w-full space-y-4">
        {faqs.map((faq, index) => (
          <AccordionPrimitive.Item
            key={index}
            value={`item-${index}`}
            className="bg-white rounded-lg border border-border-gray overflow-hidden"
          >
            <AccordionPrimitive.Header>
              <AccordionPrimitive.Trigger className="flex w-full items-center justify-between px-6 py-4 text-left hover:bg-light-bg transition-colors group">
                <span className="text-base md:text-lg font-semibold text-dark-text pr-4">
                  {faq.question}
                </span>
                <ChevronDown
                  className="h-5 w-5 text-body-text transition-transform duration-300 group-data-[state=open]:rotate-180 flex-shrink-0"
                  aria-hidden
                />
              </AccordionPrimitive.Trigger>
            </AccordionPrimitive.Header>
            <AccordionPrimitive.Content className="overflow-hidden data-[state=open]:animate-accordion-down data-[state=closed]:animate-accordion-up">
              <div className="px-6 pb-4 pt-2 text-sm md:text-base text-body-text leading-relaxed">
                {faq.answer}
              </div>
            </AccordionPrimitive.Content>
          </AccordionPrimitive.Item>
        ))}
      </AccordionPrimitive.Root>
    </div>
  );
};

export default FAQAccordion;